import {Injectable} from '@angular/core';
import { DelegateType } from '../../shared/models/utility.model';

@Injectable({
	providedIn: 'root',
})
export class MobileDelegateService {
	readonly exceptionMessage = 'Error: error';

	constructor() {
	}

	setDelegateData(delegate: DelegateType, ...param): Promise<any> {
		return new Promise((resolve, reject) => {
			try {
				window[`flutter_inappwebview`]
					?.callHandler(delegate, ...param)
					.then((res) => {
						const containsExpection = this.isResponseContainsExceptionError(res);
						if (containsExpection) {
							reject(res);
						} else {
							resolve(res);
						}
					})
					.catch((error) => {
						reject(error);
					});
			} catch (err) {
				reject(err);
			}
		});
	}

	getDelegateData(delegate: DelegateType): Promise<any> {
		return new Promise((resolve, reject) => {
			try {
				if (!window[`flutter_inappwebview`]) {
					reject('unable to get flutter delegate');
					return;
				}
				window[`flutter_inappwebview`]
					.callHandler(delegate)
					.then((res) => {
						const containsException = this.isResponseContainsExceptionError(res);
						if (containsException) {
							reject(res);
						} else {
							resolve(res);
						}
					})
					.catch((error) => {
						reject(error);
					});
			} catch (err) {
				reject(err);
			}
		});
	}

	isResponseContainsExceptionError(res) {
		if (!res) {
			return false;
		}
		return `${res}`.toLowerCase().includes(this.exceptionMessage.toLowerCase());
	}
}
